<app-barra-crud [state]="state" (salvando)="salvar()" (voltando)="busca()" (inserindo)="novo()" (editando)="editar()"
  (excluindo)="excluir()" (cancelando)="cancelar()" [formValido]="f.valid">
</app-barra-crud>

<div class="conteudo cadastro">
  <app-loading [exibir]="carregando"></app-loading>
  <form role="form" #f="ngForm" novalidate>
    <nav class="topo-abas">
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a translate id="dados-principais-tab" href="#dados-principais" aria-controls="dados-principais"
          aria-selected="true" class="nav-item nav-link active" data-toggle="tab" role="tab">
          {{'parametros.dealer.cadastro.dadosPrincipais.abaDadosPrincipais'}}
        </a>
        <a translate id="endereco-tab" href="#endereco" aria-controls="endereco" aria-selected="false"
          class="nav-item nav-link" data-toggle="tab" role="tab">
          {{'parametros.dealer.cadastro.endereco.abaEndereco'}}
        </a>
        <a translate id="contato-tab" href="#contato" aria-controls="contato" aria-selected="false"
          class="nav-item nav-link" data-toggle="tab" role="tab">
          {{'parametros.dealer.cadastro.contatos.abaContatos'}}
        </a>
        <!-- <a id="jlr-tab" href="#jlr" aria-controls="jlr" aria-selected="false" class="nav-item nav-link"
          data-toggle="tab" role="tab">
          Dados JLR
        </a> -->
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div id="dados-principais" aria-labelledby="dados-principais-tab" class="tab-pane fade show active"
        role="tabpanel">
        <header translate class="titulo">{{'parametros.dealer.cadastro.dadosPrincipais.abaDadosPrincipais'}}</header>
        <div class="container-fluid">
          <div class="row">
            <div class="form-group col-lg-12">
              <small translate class="form-text text-muted">{{'parametros.dealer.cadastro.CampoObrigatorio'}}</small>
            </div>
          </div>
          <div class="row">
            <app-text-box class="col-md-4 col-lg-4" label="ID" name="idDealer" [(ngModel)]="model.id"
              placeholder="{{'parametros.dealer.cadastro.dadosPrincipais.codigoIDPlaceHolder' | translate}}"
              [ativo]="false">
            </app-text-box>
          </div>
          <div class="row">
            <app-text-box [state]="state" class="col-md-4 col-lg-4" maxLength='20'
              label="{{'parametros.dealer.cadastro.dadosPrincipais.codigoDealer' | translate}}" name="codigoDealer"
              [(ngModel)]="model.codigo" obrigatorio="true" required
              placeholder="{{'parametros.dealer.cadastro.dadosPrincipais.codigoDealerPlaceHolder' | translate}}">
            </app-text-box>
            <app-dropdown-list [state]="state" class="col-md-4 col-lg-4"
              label="{{'parametros.dealer.cadastro.dadosPrincipais.tipoDealer' | translate}}" name="tipoDealer"
              [(ngModel)]="model.idTipo" obrigatorio="true" required [itens]="itensTipoDealer">
            </app-dropdown-list>
            <app-dropdown-list [state]="state" class="col-md-4 col-lg-4"
              label="{{'parametros.dealer.cadastro.dadosPrincipais.statusDealer' | translate}}" name="statusDealer"
              [(ngModel)]="model.status" obrigatorio="true" required [itens]="itensStatusDealer">
            </app-dropdown-list>
          </div>
          <div class="row">
            <app-text-box mascara='00.000.000/0000-00' class="col-md-4 col-lg-4" maxLength='18'
              label="{{'parametros.dealer.cadastro.dadosPrincipais.CNPJDealer' | translate}}" name="cnpjDealer"
              [(ngModel)]="model.cnpj" obrigatorio="true" required
              placeholder="{{'parametros.dealer.cadastro.dadosPrincipais.CNPJDealerPlaceHolder' | translate}}">
            </app-text-box>
            <app-text-box [state]="state" class="col-md-8 col-lg-8" maxLength='100'
              label="{{'parametros.dealer.cadastro.dadosPrincipais.nomeDealer' | translate}}" name="nomeDealer"
              [(ngModel)]="model.nome" obrigatorio="true" required
              placeholder="{{'parametros.dealer.cadastro.dadosPrincipais.nomeDealerPlaceHolder' | translate}}">
            </app-text-box>
          </div>
          <div class="row">
            <app-text-box class="col-md-6 col-lg-6" [state]="state" maxLength='20'
              label="{{'parametros.dealer.cadastro.dadosPrincipais.inscricaoMunicipal' | translate}}"
              name="inscricaoMunicipal" [(ngModel)]="model.inscricaoMunicipal"
              placeholder="{{'parametros.dealer.cadastro.dadosPrincipais.inscricaoMunicipalPlaceHolder' | translate}}">
            </app-text-box>
            <app-text-box class="col-md-6 col-lg-6" [state]="state" maxLength='20'
              label="{{'parametros.dealer.cadastro.dadosPrincipais.inscricaoEstadual' | translate}}"
              name="inscricaoEstadual" [(ngModel)]="model.inscricaoEstadual"
              placeholder="{{'parametros.dealer.cadastro.dadosPrincipais.inscricaoEstadualPlaceHolder' | translate}}">
            </app-text-box>
            <app-dropdown-list class="col-md-6 col-lg-4" [state]="state"
              label="{{'parametros.dealer.cadastro.dadosPrincipais.grupoEconomico' | translate}}" name="idGrupo"
              [(ngModel)]="model.jlr.idGrupo" obrigatorio="true" [itens]="itensGrupo">
            </app-dropdown-list>
            <app-dropdown-list class="col-md-6 col-lg-4" [state]="state"
              label="{{'parametros.dealer.cadastro.dadosPrincipais.grupoImportador' | translate}}"
              name="idGrupoImportador" [(ngModel)]="model.jlr.idGrupoImportador" obrigatorio="true"
              [itens]="itensGrupoImp">
            </app-dropdown-list>
            <app-dropdown-list class="col-md-12 col-lg-4" [state]="state"
              label="{{'parametros.dealer.cadastro.dadosPrincipais.mercado' | translate}}" name="idMercado"
              [(ngModel)]="model.jlr.idMercado" obrigatorio="false" [itens]="itensMercado">
            </app-dropdown-list>
          </div>
        </div>
      </div>
      <div id="endereco" aria-labelledby="endereco-tab" class="tab-pane fade" role="tabpanel">
        <header translate class="titulo" tabindex="1">{{'parametros.dealer.cadastro.endereco.abaEndereco'}}</header>
        <div class="container-fluid">
          <div class="row">
            <div class="form-group col-lg-12">
              <small translate class="form-text text-muted">{{'parametros.dealer.cadastro.CampoObrigatorio'}}</small>
            </div>
          </div>
          <div class="row">
            <app-text-box [state]="state" mascara="0{5}-0{3}" class="col-md-6 col-lg-3"
              label="{{'parametros.dealer.cadastro.endereco.cep' | translate}}" name="cep" maxLength='9'
              [(ngModel)]="model.endereco.cep" obrigatorio="true"
              placeholder="{{'parametros.dealer.cadastro.endereco.cepPlaceHolder' | translate}}" (keyup)="buscarCEP()">
            </app-text-box>
          </div>
          <div class="row">
            <app-dropdown-list [state]="state" class="col-md-6 col-lg-3"
              label="{{'parametros.dealer.cadastro.endereco.pais' | translate}}" name="idPais"
              [(ngModel)]="model.endereco.idPais" obrigatorio="true" [itens]="itensPais">
            </app-dropdown-list>
            <app-dropdown-list [state]="state" class="col-md-6 col-lg-3"
              label="{{'parametros.dealer.cadastro.endereco.regiao' | translate}}" name="idRegiao"
              [(ngModel)]="model.endereco.idRegiao" obrigatorio="true" [itens]="itensRegiao"
              (selecionar)="filtrarEstado(model.endereco.idRegiao)">
            </app-dropdown-list>
            <app-dropdown-list [state]="state" class="col-md-6 col-lg-3"
              label="{{'parametros.dealer.cadastro.endereco.uf' | translate}}" name="idUF"
              [(ngModel)]="model.endereco.idUF" obrigatorio="true" [itens]="itensUF"
              (selecionar)="filtrarCidade(model.endereco.idUF)">
            </app-dropdown-list>
            <app-dropdown-list [state]="state" class="col-md-6 col-lg-3"
              label="{{'parametros.dealer.cadastro.endereco.cidade' | translate}}" name="idCidade"
              [(ngModel)]="model.endereco.idCidade" obrigatorio="true" [itens]="itensCidade">
            </app-dropdown-list>
          </div>
          <div class="row">
            <app-text-box class="col-md-8 col-lg-8" [state]="state" maxLength='100'
              label="{{'parametros.dealer.cadastro.endereco.logradouro' | translate}}" name="logradouro"
              [(ngModel)]="model.endereco.logradouro" obrigatorio="true"
              placeholder="{{'parametros.dealer.cadastro.endereco.logradouroPlaceHolder' | translate}}">
            </app-text-box>
            <app-text-box class="col-md-4 col-lg-4" [state]="state" maxLength='20'
              label="{{'parametros.dealer.cadastro.endereco.numero' | translate}}" name="numeroEndereco"
              [(ngModel)]="model.endereco.numero" obrigatorio="true"
              placeholder="{{'parametros.dealer.cadastro.endereco.numeroPlaceHolder' | translate}}">
            </app-text-box>
          </div>
          <div class="row">
            <app-text-box class="col-md-6 col-lg-6" [state]="state" maxLength='100'
              label="{{'parametros.dealer.cadastro.endereco.bairro' | translate}}" name="bairro"
              [(ngModel)]="model.endereco.bairro" obrigatorio="false"
              placeholder="{{'parametros.dealer.cadastro.endereco.bairroPlaceHolder' | translate}}">
            </app-text-box>
            <app-text-box class="col-md-6 col-lg-6" [state]="state" maxLength='100'
              label="{{'parametros.dealer.cadastro.endereco.complemento' | translate}}" name="complemento"
              [(ngModel)]="model.endereco.complemento"
              placeholder="{{'parametros.dealer.cadastro.endereco.complementoPlaceHolder' | translate}}">
            </app-text-box>
          </div>
        </div>
      </div>
      <div id="contato" aria-labelledby="contato-tab" class="tab-pane fade" role="tabpanel">
        <header translate class="titulo" tabindex="2">{{'parametros.dealer.cadastro.contatos.abaContatos'}}</header>
        <div class="container-fluid">
          <div class="row">
            <div class="form-group col-lg-12">
              <small translate class="form-text text-muted">{{'parametros.dealer.cadastro.CampoObrigatorio'}}</small>
            </div>
          </div>
          <hr />
          <h5 translate>{{'parametros.dealer.cadastro.contatos.contato'}}</h5>
          <div class="row">
            <app-text-box class="col-lg-6" [state]="state" maxLength='100'
              label="{{'parametros.dealer.cadastro.contatos.nomeContato' | translate}}" name="nomeContato"
              [(ngModel)]="model.contato.nome" obrigatorio="true"
              placeholder="{{'parametros.dealer.cadastro.contatos.nomeContatoPlaceHolder' | translate}}">
            </app-text-box>
          </div>
          <div class="row">
            <app-text-box mascara="0{3}" [state]="state" class="col-md-4 col-lg-2"
              label="{{'parametros.dealer.cadastro.contatos.dddContato' | translate}}" name="DddContato"
              [(ngModel)]="model.contato.ddd" obrigatorio="true"
              placeholder="{{'parametros.dealer.cadastro.contatos.dddContatoPlaceHolder' | translate}}">
            </app-text-box>
            <app-text-box mascara="0{4}-0{5}" [state]="state" class="col-md-8 col-lg-3"
              label="{{'parametros.dealer.cadastro.contatos.telefoneContato' | translate}}" name="telefoneContato"
              [(ngModel)]="model.contato.telefone" obrigatorio="true"
              placeholder="{{'parametros.dealer.cadastro.contatos.telefoneContatoPlaceHolder' | translate}}">
            </app-text-box>
            <app-text-box class="col-lg-7" [state]="state" maxLength='100'
              label="{{'parametros.dealer.cadastro.contatos.emailContato' | translate}}" name="emailContato"
              [(ngModel)]="model.contato.email" obrigatorio="true"
              placeholder="{{'parametros.dealer.cadastro.contatos.emailContatoPlaceHolder' | translate}}">
            </app-text-box>
          </div>
          <hr />
          <h5 translate>{{'parametros.dealer.cadastro.contatos.contatoTitular'}}</h5>
          <div class="row">
            <app-text-box class="col-lg-6" [state]="state" maxLength='100'
              label="{{'parametros.dealer.cadastro.contatos.nomeContatoTitular' | translate}}" name="nomeContatoTitular"
              [(ngModel)]="model.contatoTitular.nome" obrigatorio="true"
              placeholder="{{'parametros.dealer.cadastro.contatos.nomeContatoTitularPlaceHolder' | translate}}">
            </app-text-box>
          </div>
          <div class="row">
            <app-text-box mascara="0{3}" [state]="state" class="col-md-4 col-lg-2"
              label="{{'parametros.dealer.cadastro.contatos.dddContatoTitular' | translate}}" name="DddContatoTitular"
              [(ngModel)]="model.contatoTitular.ddd" obrigatorio="true"
              placeholder="{{'parametros.dealer.cadastro.contatos.dddContatoTitularPlaceHolder' | translate}}">
            </app-text-box>
            <app-text-box mascara="0{4}-0{5}" [state]="state" class="col-md-8 col-lg-3"
              label="{{'parametros.dealer.cadastro.contatos.telefoneContatoTitular' | translate}}"
              name="telefoneContatoTitular" [(ngModel)]="model.contatoTitular.telefone" obrigatorio="true"
              placeholder="{{'parametros.dealer.cadastro.contatos.telefoneContatoTitularPlaceHolder' | translate}}">
            </app-text-box>
            <app-text-box class="col-lg-7" [state]="state" maxLength='100' label="{{'parametros.dealer.cadastro.contatos.emailContatoTitular' | translate}}"
              name="emailContatoTitular" [(ngModel)]="model.contatoTitular.email" obrigatorio="true"
              placeholder="{{'parametros.dealer.cadastro.contatos.emailContatoTitularPlaceHolder' | translate}}">
            </app-text-box>
          </div>
        </div>
      </div>
      <!-- <div id="jlr" aria-labelledby="jlr-tab" class="tab-pane fade" role="tabpanel">
        <header class="titulo">Dados JLR</header>
        <div class="container-fluid">
          <div class="row">
            <div class="form-group col-lg-12">
              <small class="form-text text-muted">Campos com (*) são de preenchimento obrigatório.</small>
            </div>
          </div>
          <div *ngIf="true" class="row">
            <app-dropdown-list class="col-md-6 col-lg-3" [state]="state" label="Área Manager RAM" name="areaManagerRam"
              [(ngModel)]="model.jlr.areaManagerRam" placeholder="Área Manager RAM..." [itens]="itensRAM">
            </app-dropdown-list>
            <app-dropdown-list class="col-md-6 col-lg-3" [state]="state" label="Área Manager RTM" name="areaManagerRtm"
              [(ngModel)]="model.jlr.areaManagerRtm" placeholder="Área Manager RTM..." [itens]="itensRTM">
            </app-dropdown-list>
            <app-dropdown-list class="col-md-6 col-lg-3" [state]="state" label="Área Manager RBM" name="areaManagerRbm"
              [(ngModel)]="model.jlr.areaManagerRbm" placeholder="Área Manager RBM..." [itens]="itensRBM">
            </app-dropdown-list>
            <app-dropdown-list class="col-md-6 col-lg-3" [state]="state" label="Área Manager MKT" name="areaManagerMkt"
              [(ngModel)]="model.jlr.areaManagerMkt" placeholder="Área Manager MKT..." [itens]="itensMKT">
            </app-dropdown-list>
          </div>
          <div class="row">
            <app-dropdown-list class="col-md-6 col-lg-4" [state]="state" label="Grupo Econômico" name="idGrupo"
              [(ngModel)]="model.jlr.idGrupo" obrigatorio="true" [itens]="itensGrupo">
            </app-dropdown-list>
            <app-dropdown-list class="col-md-6 col-lg-4" [state]="state" label="Grupo Importador" name="idGrupoImportador"
              [(ngModel)]="model.jlr.idGrupoImportador" obrigatorio="true" [itens]="itensGrupoImp">
            </app-dropdown-list>
            <app-dropdown-list class="col-md-12 col-lg-4" [state]="state" label="Mercado" name="idMercado"
              [(ngModel)]="model.jlr.idMercado" obrigatorio="false" [itens]="itensMercado">
            </app-dropdown-list>
          </div>
        </div>
      </div> -->
    </div>
  </form>
</div>